import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '../Assets/15.svg'; 


const AppNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear(); 
    navigate('/admin/login');
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: '#343a40' }}>
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <Box
            sx={{
              width: 50,
              height: 50,
              backgroundImage: `url(${logo})`, 
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              marginRight: 2,
            }}
          />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white' }}>
            TheGame
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }} /> 
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleLogout}
          sx={{
            borderColor: 'white',
            color: 'white',
            '&:hover': {
              borderColor: 'white',
              backgroundColor: '#555',
            },
          }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default AppNavbar;
